<template>
    <div v-show="visible" style="position: absolute; left: 0px; top: 0px; right: 0px; bottom: 0px; width: 100%; height: 100%; background-color: rgba(255, 255, 255, 0.6); z-index: 20000;">
        <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="font-size: 6rem; color: #d97a15; position: absolute;left: calc(50% - 3rem); top: calc(50% - 3rem);"></i>
    </div>
</template>

<script>
    export default {
        props: ['visible'],
    }
</script>
